<script>
export default {
  components: {},
}
</script>

<template>
<div>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <slot />
    </div>
  </div>
  <footer class="text-center">
            {{ new Date().getFullYear() }} © {{app_name}}
        </footer>
</div>
</template>
